import { dispatchEvent } from '@/global/utils'
import {
  ButtonType,
  EventName
} from '@/global/utils/analytics-events/types/common'
import { sendGTMEvent } from '@next/third-parties/google'
import { MEForm } from './MECompanyForm.types'
import { SimulationAnswer } from '@/modules/simulator/hooks/useSimulationReducer/useSimulationReducer'

const strings = {
  title: 'Agora, precisamos de alguns dados:',
  submitLabel: 'Concluir cotação'
}

const dispatchAnalyticsEvents = (data: MEForm) => {
  dispatchEvent({
    eventName: EventName.SIMULATION_SENT,
    buttonName: strings.submitLabel,
    buttonType: ButtonType.NEW_PAGE
  })

  sendGTMEvent({ event: 'city_answered' })
  sendGTMEvent({ nome_cidade: data.city })
  sendGTMEvent({ event: 'me_b2b_form_sent' })
}

const buildPayload = (
  data: MEForm,
  originalAnswers: SimulationAnswer
): SimulationAnswer => {
  return {
    ...originalAnswers,
    responsibleName: data.responsibleName,
    responsiblePhone: data.telefone,
    responsibleEmail: data.responsibleEmail,
    companyCity: data.city,
    companyCnpj: data.cnpj
  }
}

export { strings, dispatchAnalyticsEvents, buildPayload }
